<div *ngIf="loginSuccess">
  <router-outlet></router-outlet>
</div>
